import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { checkModeratorPinRateLimit, getLocalParticipant, getParticipantById, getPinnedParticipant, getSharedVideoParticipant, isLocalParticipantModerator, pinParticipant, setModeratorPin, SET_MODERATOR_PIN } from '../../../base/participants';
import { Icon, IconShareVideo, IconMenuThumb, IconModeratorPin, IconUserPinned } from '../../../base/icons';
import { YOUTUBE_PLAYER_PARTICIPANT_NAME } from '../../../shared-video/constants';
import { translate } from '../../../base/i18n';
import { setCustomParticipantVisible } from '../../../base/conference';
import { exitTileViewIfNeeded } from '../../../conference/filmStripViewManager';
import { LAYOUTS } from '../../../video-layout';
import { BaseIndicator } from '../../../base/react';
import { setLabelsVisible } from '../../../toolbox/actions.web';
import { selectParticipantInLargeVideo } from '../../../large-video/actions.any';
import logger from '../../logger';
import { getPictureInPictureModeConfig } from '../../../base/config/functions.any';
import { getFirstName } from '../../../display-name';
import { truncateText } from '../../../base/environment/utils';
const visibleButton = new Set(interfaceConfig.TOOLBAR_BUTTONS);
function SharedVideoThumbnail({ t, _isCustomParticipantVisible, _isCustomParticipantEveryone, _isPersonModerator, _visibleButtons, conference, filmStripView, _isPictureInPictureEnabled, ownerId, localParticipant, sharedParticipantName }) {
    const sharedVideoParticipant = useSelector(getSharedVideoParticipant);
    const pinnedParticipant = useSelector(getPinnedParticipant);
    const containerRef = useRef(null);
    const videoContainerRef = useRef(null);
    const contextMenuInitialized = useRef(false);
    const dispatch = useDispatch();
    const onPinToggle = useCallback((event) => {
        if (event) {
            event.stopPropagation();
        }
        if (!sharedVideoParticipant) {
            return;
        }
        const isCurrentlyPinned = Boolean(sharedVideoParticipant.pinned
            || (pinnedParticipant && pinnedParticipant.id === sharedVideoParticipant.id));
        dispatch(setCustomParticipantVisible(false));
        if (isCurrentlyPinned) {
            dispatch(pinParticipant(null));
            dispatch(selectParticipantInLargeVideo(undefined));
        }
        else {
            dispatch(pinParticipant(sharedVideoParticipant.id, true));
            dispatch(selectParticipantInLargeVideo(sharedVideoParticipant.id, {
                selectionSource: 'shared-video-pin',
                forceSelection: true
            }));
        }
        exitTileViewIfNeeded(dispatch, filmStripView);
        dispatch(setLabelsVisible(false));
    }, [dispatch, sharedVideoParticipant, pinnedParticipant, filmStripView]);
    const onClick = useCallback((event) => {
        var _a, _b;
        if (event) {
            const target = event.target;
            if (((_a = target === null || target === void 0 ? void 0 : target.closest) === null || _a === void 0 ? void 0 : _a.call(target, '.custom-participnt-dialog-parent'))
                || ((_b = target === null || target === void 0 ? void 0 : target.closest) === null || _b === void 0 ? void 0 : _b.call(target, '.displayNameContainer'))) {
                return;
            }
        }
        onPinToggle(event);
    }, [onPinToggle]);
    const displayLabel = useMemo(() => {
        const participantName = ownerId === (localParticipant === null || localParticipant === void 0 ? void 0 : localParticipant.id) ? 'You' : getFirstName(sharedParticipantName) || 'Moderator';
        const textlimit = window.innerWidth < 1024 || _isPictureInPictureEnabled ? 10 : 26;
        const translatedText = t('dialog.youtubeSharingUser', { displayName: participantName });
        const displayNameText = truncateText(translatedText, textlimit);
        return displayNameText;
    }, [sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.name, _isPictureInPictureEnabled, sharedParticipantName, ownerId, localParticipant === null || localParticipant === void 0 ? void 0 : localParticipant.id, t]);
    const onModeratorPinClick = useCallback((event) => {
        if (event) {
            event.stopPropagation();
        }
        if (!sharedVideoParticipant) {
            return;
        }
        if (checkModeratorPinRateLimit(dispatch, t)) {
            return;
        }
        const myId = conference === null || conference === void 0 ? void 0 : conference.myUserId();
        const isModeratorPinned = Boolean(sharedVideoParticipant.moderatorPin);
        const pinAction = isModeratorPinned ? 'unpin' : 'pin';
        dispatch(setModeratorPin(sharedVideoParticipant.id, pinAction));
        if (pinAction === 'pin') {
            dispatch(pinParticipant(sharedVideoParticipant.id, true));
            dispatch(selectParticipantInLargeVideo(sharedVideoParticipant.id, {
                selectionSource: 'moderator-pin',
                forceSelection: true
            }));
            exitTileViewIfNeeded(dispatch, filmStripView);
        }
        else {
            dispatch(pinParticipant(null));
            dispatch(selectParticipantInLargeVideo(undefined));
        }
        if (conference) {
            conference.sendMessage({
                type: SET_MODERATOR_PIN,
                participant_id: sharedVideoParticipant.id,
                senderId: myId,
                action: pinAction
            });
        }
        dispatch(setLabelsVisible(false));
    }, [dispatch, sharedVideoParticipant, conference, filmStripView, t]);
    const _renderTopIndicators = useMemo(() => (React.createElement("div", null,
        Boolean((sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.pinned) && !(sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.moderatorPin)) && (React.createElement(BaseIndicator, { className: 'indicator show-inline', icon: IconUserPinned, iconClassName: 'indicatoricon pipstroke', iconSize: '12px', tooltipKey: t('videothumbnail.userispinned'), tooltipPosition: 'bottom-left' })),
        Boolean(sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.moderatorPin) && (React.createElement(BaseIndicator, { className: 'indicator show-inline', icon: IconModeratorPin, iconClassName: 'indicatoricon pipstroke', iconSize: '12px', tooltipKey: t('videothumbnail.pinByModerator'), tooltipPosition: 'bottom-left' })))), [t, sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.pinned, sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.moderatorPin]);
    const content = useMemo(() => (React.createElement("div", { className: 'popupmenu__item_dialog' },
        _isPersonModerator && (_visibleButtons === null || _visibleButtons === void 0 ? void 0 : _visibleButtons.has('moderator-pin')) && (React.createElement("li", { className: 'popupmenu__item private_msg_box' },
            React.createElement("button", { className: 'popupmenu__link', onClick: onModeratorPinClick },
                React.createElement("span", { className: 'popupmenu__icon' },
                    React.createElement(Icon, { src: IconModeratorPin })),
                React.createElement("span", { className: 'popupmenu__text' }, (sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.moderatorPin)
                    ? t('videothumbnail.unpinEveryone').toString()
                    : t('videothumbnail.pinEveryone').toString())))),
        (_visibleButtons === null || _visibleButtons === void 0 ? void 0 : _visibleButtons.has('pin-user')) && (React.createElement("li", { className: 'popupmenu__item private_msg_box' },
            React.createElement("button", { className: 'popupmenu__link', onClick: onPinToggle },
                React.createElement("span", { className: 'popupmenu__icon' },
                    React.createElement(Icon, { src: IconUserPinned })),
                React.createElement("span", { className: 'popupmenu__text' }, (sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.pinned)
                    ? t('videothumbnail.unpinMe').toString()
                    : t('videothumbnail.pinMe').toString())))))), [_isPersonModerator, _visibleButtons, onPinToggle, onModeratorPinClick, t, sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.pinned, sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.moderatorPin]);
    // Build and initialize jQuery contextMenu
    useEffect(() => {
        if (!sharedVideoParticipant) {
            return;
        }
        if (typeof $ === 'undefined' || typeof $.contextMenu !== 'function') {
            return;
        }
        const selector = '#sharedVideoThumbnailContainer';
        // Destroy existing context menu before recreating
        if (contextMenuInitialized.current) {
            try {
                $.contextMenu('destroy', selector);
            }
            catch (e) {
                // Ignore errors when destroying
            }
        }
        // Build context menu items
        const contextMenuItems = {};
        // Add Pin/Unpin option
        if (_visibleButtons === null || _visibleButtons === void 0 ? void 0 : _visibleButtons.has('pin-user')) {
            contextMenuItems.pin = {
                name: (sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.pinned) ? t('videothumbnail.unpinMe') : t('videothumbnail.pinMe'),
                callback: () => {
                    onPinToggle();
                }
            };
        }
        // Add Pin Everyone option (only for moderators)
        if (_isPersonModerator && (_visibleButtons === null || _visibleButtons === void 0 ? void 0 : _visibleButtons.has('moderator-pin'))) {
            contextMenuItems.pinEveryone = {
                name: (sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.moderatorPin) ? t('videothumbnail.unpinEveryone') : t('videothumbnail.pinEveryone'),
                callback: () => {
                    onModeratorPinClick();
                }
            };
        }
        // Initialize jQuery contextMenu
        $.contextMenu({
            selector,
            zIndex: 10000,
            items: contextMenuItems,
            events: {
                show(options) {
                    // Update pin text based on current state
                    if (options.items.pin) {
                        options.items.pin.name = t((sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.pinned) ? 'videothumbnail.unpinMe' : 'videothumbnail.pinMe');
                    }
                    // Update pin everyone text
                    if (options.items.pinEveryone) {
                        options.items.pinEveryone.name = t((sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.moderatorPin) ? 'videothumbnail.unpinEveryone' : 'videothumbnail.pinEveryone');
                    }
                }
            }
        });
        contextMenuInitialized.current = true;
        // Cleanup function
        return () => {
            if (contextMenuInitialized.current && typeof $ !== 'undefined' && typeof $.contextMenu === 'function') {
                try {
                    $.contextMenu('destroy', selector);
                    contextMenuInitialized.current = false;
                }
                catch (e) {
                    // Ignore errors when destroying
                }
            }
        };
    }, [
        sharedVideoParticipant,
        _isPersonModerator,
        _visibleButtons,
        conference,
        filmStripView,
        dispatch,
        t,
        sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.pinned,
        sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.moderatorPin,
        onPinToggle,
        onModeratorPinClick
    ]);
    if (!sharedVideoParticipant) {
        logger.log('No shared video participant found', sharedVideoParticipant);
        return null;
    }
    const isPinned = Boolean(sharedVideoParticipant.pinned
        || sharedVideoParticipant.moderatorPin
        || (pinnedParticipant && pinnedParticipant.id === sharedVideoParticipant.id));
    const isYouTube = sharedVideoParticipant.name === YOUTUBE_PLAYER_PARTICIPANT_NAME;
    // For YouTube videos, use the participant ID (which is the YouTube video ID) to construct thumbnail URL
    // This matches the pattern used in Thumbnail.js for rendering fake participants
    const thumbnailUrl = isYouTube
        ? `https://img.youtube.com/vi/${sharedVideoParticipant.id}/0.jpg`
        : null;
    return (React.createElement("div", { className: `filmstrip__videos ${filmStripView === LAYOUTS.TILE_VIEW ? 'videocontainer' : ''}`, id: 'sharedVideoThumbnailContainer', onClick: onClick, ref: containerRef },
        React.createElement("div", { className: `shared-thumbnail videocontainer ${isPinned ? 'videoContainerFocused' : ''}`, ref: videoContainerRef },
            React.createElement("div", { className: 'videocontainer__background' }),
            React.createElement("div", { className: 'videocontainer__toptoolbar' }, _renderTopIndicators),
            thumbnailUrl ? (React.createElement("img", { className: 'sharedVideoAvatar', src: thumbnailUrl, alt: sharedVideoParticipant.name })) : (React.createElement("div", { className: 'avatar-container-custom-participnt' },
                React.createElement(Icon, { size: 50, src: IconShareVideo }))),
            React.createElement("div", { className: 'displayNameMainContainer' },
                React.createElement("div", { className: 'displayNameContainer' },
                    React.createElement("span", { className: 'displayName' }, displayLabel))),
            React.createElement("span", { className: 'custom-participnt-dialog-parent' },
                React.createElement("span", { className: 'custom-participnt-parent' },
                    React.createElement(Icon, { size: '20', src: IconMenuThumb })),
                React.createElement("div", { className: 'custom-participnt-dialog' }, content)))));
}
/**
 * Maps (parts of) the Redux state to the associated SharedVideoThumbnail props.
 * @param {*} state - The Redux state.
 * @returns {Props}
 */
function mapStateToProps(state) {
    var _a;
    const { isCustomParticipantVisible, filmStripView, conference, isCustomParticipantEveryone } = state['features/base/conference'];
    const isPictureInPictureEnabled = getPictureInPictureModeConfig(state);
    const { ownerId } = state['features/shared-video'];
    const localParticipant = getLocalParticipant(state);
    const sharedParticipantName = ownerId ? (_a = getParticipantById(state, ownerId)) === null || _a === void 0 ? void 0 : _a.name : 'Guest';
    return {
        _isCustomParticipantVisible: isCustomParticipantVisible,
        _isCustomParticipantEveryone: isCustomParticipantEveryone,
        _isPersonModerator: isLocalParticipantModerator(state),
        _visibleButtons: visibleButton,
        filmStripView,
        conference,
        _isPictureInPictureEnabled: isPictureInPictureEnabled,
        ownerId,
        localParticipant,
        sharedParticipantName
    };
}
export default connect(mapStateToProps)(translate(SharedVideoThumbnail));
